import { render } from "./SeoBox.vue?vue&type=template&id=217925f3&scoped=true"
import script from "./SeoBox.vue?vue&type=script&lang=js"
export * from "./SeoBox.vue?vue&type=script&lang=js"

import "./SeoBox.vue?vue&type=style&index=0&id=217925f3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217925f3"]])

export default __exports__